module.exports = __webpack_public_path__ + "static/media/so-icon__wool.d10904eb.svg";